import { atom, useRecoilState } from "recoil";

const claimModalState = atom({
  key: "claimModalState",
  default: false,
});

export const useClaimModalStore = () => {
  const [isOpen, setIsOpen] = useRecoilState(claimModalState);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return {
    isOpen,
    onOpen,
    onClose,
  };
};
